import {createListenerMiddleware} from '@reduxjs/toolkit';
import {AppDispatch, ExtraArgs} from '../../createStore';
import {RootState} from '../../rootReducer';
import {addMeetingsListeners} from '../../effects/meetings';

const listenerMiddleware = createListenerMiddleware<RootState, AppDispatch, ExtraArgs>();

addMeetingsListeners(listenerMiddleware.startListening);

export default listenerMiddleware;
